import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=4b4fbb4d"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=4b4fbb4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports